<template>
  <nav class="level">
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Jobs</p>
        <p class="title">3,456</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Locations</p>
        <p class="title">4</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Departments</p>
        <p class="title">24</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Candidates</p>
        <p class="title">789</p>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    name: 'stats-bar',
  };
</script>



// WEBPACK FOOTER //
// src/components/jobs/StatsBar.vue